var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H37.9973C43.5202 0 47.9973 4.47715 47.9973 10V37.9973C47.9973 43.5202 43.5202 47.9973 37.9973 47.9973H10C4.47715 47.9973 0 43.5202 0 37.9973V10Z",
    fill: "#D0438D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.99 14.0028V33.9945",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.988 17.0016H21.4911C20.5632 17.0016 19.6734 17.3702 19.0173 18.0263C18.3611 18.6824 17.9926 19.5723 17.9926 20.5001C17.9926 21.428 18.3611 22.3179 19.0173 22.974C19.6734 23.6301 20.5632 23.9987 21.4911 23.9987H26.489C27.4169 23.9987 28.3068 24.3673 28.9629 25.0234C29.619 25.6795 29.9876 26.5693 29.9876 27.4972C29.9876 28.4251 29.619 29.315 28.9629 29.9711C28.3068 30.6272 27.4169 30.9958 26.489 30.9958H17.9926",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/Revenue.fd754aed1c59a74ae09f4de530274bc1.svg";
export { ForwardRef as ReactComponent };